import React from 'react';
import { ChevronUpIcon } from '@heroicons/react/20/solid';
import Image from 'next/image';
import { twJoin } from 'tailwind-merge';
import { TechnicalDataTile } from './types/TechnicalDataTile';
import Container from '../../shared/Container';
import { RichTextRenderer } from '../../tileRenderers/RichTextRenderer';
import TechnicalDataDropdown from './components/TechnicalDataDropdown';
import PdfIcon from '../../../../../public/images/pdf-icon.svg';

export default function TechnicalData({ tile }: { tile: TechnicalDataTile }) {
  const fixedSections = tile['technical-data-fixed']?.sections;
  const sections = tile['technical-data']?.sections;
  return (
    <Container id="technical-data" className={twJoin(!tile['full-width']?.value && 'max-w-4xl')}>
      <RichTextRenderer blocks={tile.title} className="text-center text-2xl md:text-3xl" />
      <div className="mt-6 md:mt-9">
        {fixedSections?.map((section, index) => {
          const title = section?.title;
          const properties = section?.properties;
          return (
            <TechnicalDataDropdown
              key={`technical-data-fixed-section${index}`}
              title={title}
              properties={properties}
            />
          );
        })}
        {sections?.map((section, index) => {
          const title = section?.title;
          const properties = section?.properties;
          return (
            <TechnicalDataDropdown
              key={`technical-data-section${index}`}
              title={title}
              properties={properties}
            />
          );
        })}
      </div>
      <div className="mt-12 md:mt-20">
        <RichTextRenderer
          blocks={tile['downloads-title']}
          className="text-center text-2xl md:text-3xl"
        />
        <div className="mt-6 md:mt-9">
          {tile.downloads?.files?.map((file, index) => (
            <div key={`download${index}`} className="border-t border-neutral-10 last:border-b">
              <a
                href={file.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex w-full items-center justify-between gap-4 py-4 duration-200 ease-in hover:bg-neutral-5 md:py-7"
              >
                <div className="flex items-center gap-3 md:gap-6">
                  <Image
                    src={PdfIcon}
                    alt="pdf icon"
                    className="h-6 w-auto md:h-9"
                    width={35}
                    height={35}
                  />
                  <h3 className=" text-left text-md font-medium md:text-2xl">{file.title}</h3>
                </div>
                <ChevronUpIcon className="h-auto w-6 flex-shrink-0 rotate-90 text-primary-100" />
              </a>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
}
